module.exports = __webpack_public_path__ + "img/help.32ac02a2.svg";